// routerMap.js

import App from "./componts/App/App";
import About from "./componts/About/About";
import User from "./componts/User/User";
import Help from "./componts/Help/Help";
import Login from "./componts/Login/Login";
import Em from "./componts/Em/Em";
import SharpFlat from "./componts/SharpFlat/SharpFlat";
import Vocals from "./componts/Vocals/Vocals";

const routerMap = [
    { path: "/", name: "App", component: App, auth: true, },
    { path: "/user", name: "User", component: User, auth: true },
    { path: "/about", name: "About", component: About, auth: true },
    { path: "/help", name: "Help", component: Help, },
    { path: "/login", name: "Login", component: Login, },
    { path: "/em", name: "Em", component: Em, },
    { path: "/sharpflat", name: "SharpFlat", component: SharpFlat, },
    { path: "/vocals", name: "Vocals", component: Vocals, },
];

export default routerMap
